import React from 'react';
import PropTypes from 'prop-types';
import { DataGrid, PageTitleWithToolTip } from '../../Common';
import { text_commonCellProps } from '../../Common/DataGrid/utils';
import { getDateRangeFilterOperator } from '../../Common/DataGrid/FilterComponents';
import { TranslateW } from '../../../Utils/Languages/Translate';
import Routes from '../../../routes';
import { CardHeader } from '@mui/material';
import { isDesktop, isMobile } from '../../../utils';

const dateRangeFilterOperator = getDateRangeFilterOperator({});

const columns = [
    {
        field: 'reweighDate',
        headerName: 'Date',
        filterOperators: dateRangeFilterOperator,
        flex: 1,
        valueFormatter: (date) => {
            if (!date) return '';
            date = new Date(date);
            return date.toLocaleDateString('en-GB')
        },
    },
    {
        field: 'gasWeight',
        headerName: 'Gas Weight',
        ...text_commonCellProps,
    },
    {
        field: 'newGasWeight',
        headerName: 'New Gas Weight',
        ...text_commonCellProps,
    },
    {
        field: 'recordedBy',
        headerName: 'Recorded By',
        ...text_commonCellProps,
    },
    {
        field: 'reason',
        headerName: 'Reason',
        ...text_commonCellProps,
    },
    {
        field: 'notes',
        headerName: 'Notes',
        ...text_commonCellProps,
    },
];

const CylinderReweighTable = ({
    assetID,
    noDataButtonOnClick
}) => (
    <DataGrid
        url={Routes.Asset.GetCylinderReweigh(assetID)}
        columns={columns}
        headerContent={
            isDesktop && (
                <CardHeader
                    title={
                        <PageTitleWithToolTip
                            pageTitle={TranslateW("cylinderReweighListView.cylinder-reweigh-history")}
                            toolTipText="This function allows users to reweigh a cylinder when adjustments need to be made to the current weight of a cylinder."
                        />
                    }
                    sx={{
                        "& .MuiCardHeader-action": { display: "flex" },
                        "& .MuiCardHeader-content": { maxWidth: "100%", textWrap: "nowrap" }
                    }}
                />
            )
        }
        noResultText="Oops... It's empty here..."
        MUIButtonText={!isMobile ? "Add Reweigh" : undefined}
        MUIButtonOnClick={!isMobile ? noDataButtonOnClick : undefined}
        showAddButton={!isMobile}
        hideExportButton
    />
);

CylinderReweighTable.propTypes = {
    assetID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    noDataButtonOnClick: PropTypes.func,
};

export default CylinderReweighTable;
